import { useContext } from 'react'

import { RegionContext } from './context'
import { TGlobalRegionState } from './types'

/**
 * Возвращает текущее состояние региональности сайта
 */
export const useRegion = (): TGlobalRegionState => useContext(RegionContext)
